import React, { useState,useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/styles';
import {
  colors,
  Avatar,
  Checkbox,
  IconButton,
  ListItem,
  Tooltip,
  Typography
} from '@material-ui/core';

import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import OfflinePinIcon from '@material-ui/icons/OfflinePin';
import getInitials from '../../../../../../common/getInitials';
import { Label } from '../../../';

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    fontSize:"0.875rem",
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },
    padding:3,
    // [theme.breakpoints.up('md')]: {
    //   padding:0
    // },
    // [theme.breakpoints.up('sm')]: {
    //   padding:0
    // },
    // [theme.breakpoints.up('xs')]: {
    //   padding:10
    // }
  },
  new: {
    position: 'relative',
    '&:before': {
      content: '" "',
      height: '100%',
      position: 'absolute',
      left: 0,
      top: 0,
      width: 4,
      backgroundColor: theme.palette.background.paper,
    },
    '& $name, & $subject': {
      fontWeight: theme.typography.fontWeightBold
    }
  },
  selected: {
    backgroundColor: theme.palette.background.default,
  },
  checkbox: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  favoriteButton: {    
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  starIcon: {
    cursor: 'pointer'
  },
  starFilledIcon: {
    color: colors.amber[400]
  },
  details: {
    minWidth: 1,
    display: 'flex',
    flexGrow: 1
  },
  avatar: {
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
    width:30,
    height:30
  },
  name: {
    whiteSpace: 'nowrap',
    [theme.breakpoints.up('md')]: {
      minWidth: 180,
      flexBasis: 180
    },
    fontSize:"0.875rem",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  content: {
    minWidth: 1,
    fontSize:"0.875rem",
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1
    }
  },
  subject: {
    width: "100%",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize:"0.875rem",
    paddingLeft:10
  },
  separator: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  message: {
    maxWidth: 800,
    flexGrow: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
    fontSize:"0.875rem"
  },
  labels: {
    display: 'flex',
    marginRight: theme.spacing(2),
    '& > * + *': {
      marginLeft: theme.spacing(1)
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
    fontSize:"0.875rem"
  },
  date: {
    whiteSpace: 'nowrap',
    fontSize:"0.875rem",
    paddingRight:5
  }
}));

const EmailItem = props => {
  const { email,id,crmEmailId, selected, onOpen, onToggle, className,handleMassAction, ...rest } = props;

  const classes = useStyles();

  const [favorited, setFavorited] = useState(email.flagged);

  const handleFavorite = () => {
    handleMassAction(favorited?'unflagged':'flagged',[email.uid]);
    setFavorited(favorited => !favorited);
  };
  const getFromName=(name)=>{
    name =(name && name.length)?name:"A";
    let newName = name.indexOf("<");
    newName = name.substring(0,newName);
    return newName || name;
  }
  // const getLabels = (status)=>{

  // }
  useEffect(()=>{
    setFavorited(favorited)
  },[favorited])
  return (
    <ListItem
      {...rest}
      className={clsx(
        classes.root,
        {
          [classes.new]: email.status==='unread',
          [classes.selected]: selected
        },
        className
      )}
      divider
    >
      <Checkbox
        checked={selected}
        className={classes.checkbox}
        color="primary"
        onChange={onToggle}
      />
      <Tooltip title="Add to favs">
        <IconButton
          className={classes.favoriteButton}
          onClick={handleFavorite}
        >
          {favorited ? (<StarIcon className={clsx(classes.starIcon, classes.starFilledIcon)} />) : (
            <StarBorderIcon className={classes.starIcon} />
          )}
        </IconButton>
      </Tooltip>
      <div className={classes.details} onClick={()=>onOpen(id,email,crmEmailId)}>
        <Avatar className={classes.avatar} src={email.from_addr_name}>
          {getInitials(email.from_addr_name)}
        </Avatar>
        <div className={classes.content}>
          <Typography className={classes.name}>
            {getFromName(email.from_addr_name)}
          </Typography>
          <Typography className={classes.subject}>{email.name}</Typography>
          
          <div className={classes.labels}>            
              {email.is_imported?<OfflinePinIcon style={{ color: colors.green[500] }} />:""}
          </div>
          <Typography
            className={classes.date}
            variant="body2"
          >
            {email.date_sent_received}
          </Typography>
        </div>
      </div>
    </ListItem>
  );
};

EmailItem.propTypes = {
  className: PropTypes.string,
  email: PropTypes.object.isRequired,
  onOpen: PropTypes.func,
  onToggle: PropTypes.func,
  selected: PropTypes.bool.isRequired
};

export default EmailItem;
